import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getCategoryCount } from '@/lib/catalog';
import SectionHeading from '@/components/feature/SectionHeading';

const STYLES: Record<string, { bubble: string; text: string }> = {
  video: { bubble: 'bg-primary-100 text-primary-700', text: 'text-primary-700' },
  software: { bubble: 'bg-accent-100 text-accent-700', text: 'text-accent-700' },
  tutorial: { bubble: 'bg-secondary-100 text-secondary-700', text: 'text-secondary-700' },
};

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-14">
      <SectionHeading
        title="分类快捷入口"
        description="按类型快速进入，视频、软件、教程一目了然。"
        icon="ri-layout-grid-line"
      />
      <div className="flex md:grid md:grid-cols-3 gap-4 overflow-x-auto md:overflow-visible f91-scroll-hidden -mx-4 px-4 md:mx-0 md:px-0">
        {categories.map((category) => {
          const style = STYLES[category.id] || STYLES.video;
          return (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group shrink-0 w-[78%] sm:w-[60%] md:w-auto rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 p-5 transition-colors"
            >
              <div className="flex items-start justify-between">
                <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${style.bubble}`}>
                  <i className={`${category.icon} text-2xl`}></i>
                </span>
                <i className={`ri-arrow-right-up-line text-xl ${style.text} opacity-0 group-hover:opacity-100 transition-opacity`}></i>
              </div>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">
                {category.name}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed min-h-[40px]">
                {category.description}
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {category.subCategories.slice(0, 3).map((sub) => (
                  <span key={sub.id} className="px-2 py-0.5 rounded-md bg-background-100 text-xs text-foreground-600">
                    {sub.name}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-xs text-foreground-500">
                共 <span className={style.text}>{getCategoryCount(category.id)}</span> 个资源
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}